var exports = {
  "kL": "xb99ab02a--1c22be--container",
  "kZ": "xb99ab02a--1c22be--image-wrapper",
};

module.exports = exports;
